import { useContext } from 'react';
import { DocumentPreviewContext } from './context';
export const useDocumentPreview = () => {
    const context = useContext(DocumentPreviewContext);
    if (!context) {
        throw new Error('useDocumentPreview must be used as a child to DocumentPreviewContext');
    }
    return context;
};
